import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39b7e05a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "update-ribbon__body" }

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateRibbon',
  setup(__props) {

const updateRibbonEl = ref<HTMLElement>();
const requestAppUpdate = () => {
  const event = new CustomEvent('app-update-requested');

  updateRibbonEl.value?.dispatchEvent(event);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "updateRibbonEl",
    ref: updateRibbonEl,
    class: "update-ribbon"
  }, [
    _createElementVNode("p", _hoisted_1, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('modules.ribbons.newVersion.text')), 1),
      _createElementVNode("button", {
        class: "update-ribbon__action",
        onClick: requestAppUpdate
      }, _toDisplayString(_ctx.$t('modules.ribbons.newVersion.button')), 1)
    ])
  ], 512))
}
}

})